import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EWsStatusActionTypes {
  SubscribePending = 'chat/wsStatus/subscribePending',
  SubscribeSucceed = 'chat/wsStatus/subscribeSucceed',
  SubscribeFailed = 'chat/wsStatus/subscribeFailed',
  UnsubscribePending = 'chat/wsStatus/unsubscribePending',
  UnsubscribeSucceed = 'chat/wsStatus/unsubscribeSucceed',
  UnsubscribeFailed = 'chat/wsStatus/unsubscribeFailed',
}

export type TWsStatusActions =
  | ITypedReduxAction<EWsStatusActionTypes.SubscribePending, void>
  | ITypedReduxAction<EWsStatusActionTypes.SubscribeSucceed, void>
  | ITypedReduxAction<EWsStatusActionTypes.SubscribeFailed, void>
  | ITypedReduxAction<EWsStatusActionTypes.UnsubscribePending, void>
  | ITypedReduxAction<EWsStatusActionTypes.UnsubscribeSucceed, void>
  | ITypedReduxAction<EWsStatusActionTypes.UnsubscribeFailed, void>;

export interface IStatusEvent {
  type: EWsClientEventType.SubscribeUsersStatus | EWsClientEventType.UnsubscribeUsersStatus;
  status: ERequestApiStatus;
}
